<template>
  <div>
    <div
      class="loading-screen"
      :class="{'dark':isDarkTheme}"
      v-if="
        !isWhiteLabel"
    >
      <aha-logo-loader />
    </div>

    <div
      class="loading-screen-white-label"
      :class="{'dark':isDarkTheme}"
      v-else
    >
      <div>
        <aha-spinner size="lg" variant="tail" />
      </div>
      <p class="mt-6">
        {{ $i18nPresenter.t('Just a moment please...') }}
      </p>
    </div>
  </div>
</template>
<script>
import Utils from '@/util'
import msTeamsUtils from '@/utils/ms-teams'

export default {
  name: 'LoadingScreen',
  components: {
  },
  data() {
    return {
      isDarkTheme: false,
    }
  },
  computed: {
    isWhiteLabel() {
      return Utils.checkWhiteLabelDomain()
    },
  },
  async created() {
    const isDarkTheme = await msTeamsUtils.isDarkThemeInMsTeams()
    this.isDarkTheme = isDarkTheme
  },
}
</script>

  <style lang="scss" scoped>
  @import "@/assets/scss/variable.scss";

  .loading-screen {
    background-color: #fff;
    max-height: -webkit-fill-available; // fix height in ios safari (with address bar)
    @apply fixed top-0 left-0 w-full h-full z-50 flex content-center;
    @apply flex-col justify-center items-center;
  }
  .dark {
    background-color: black;

    color : white;

    }

.loading-screen-white-label {
    background-color: #fff;
    @apply fixed top-0 left-0 w-full h-full z-50 flex content-center justify-center items-center;

}
  </style>
